import { createLabeledMessages } from '../../../messageUtils';
const speedMeter = {
    speedTest: 'Speed test',
    connectionProblem: 'Internet connection problem',
    repeatTest: 'Repeat test',
    excellent: 'Excellent',
    sufficient: 'Sufficient',
    insufficient: 'Insufficient',
    connectionSpeed: 'Connection speed is',
    errorDuringTest: 'An error occurred during the test',
    download: 'Download',
    upload: 'Upload',
    ping: 'Ping',
    mbs: 'MB/s',
    ms: 'ms',
    badResponse: 'Server returned a bad response – the problem is not on your side',
    connectionLost: 'Internet connection has been lost'
};
export default Object.assign({}, speedMeter, createLabeledMessages(speedMeter));
